import { AbstractControl, ValidatorFn } from '@angular/forms';

export const RejectOrderRequestValidator: ValidatorFn = (control: AbstractControl) => {
  const reason = control.get('reason')?.value;
  const otherReason = control.get('otherReason')?.value;
  if (!reason) {
    return { dataRequired: true };
  }
  if (reason === 'Other' && !otherReason) {
    return { dataRequired: true };
  }
  return null;
};
